import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import Constants from '../../submodules/logictry_config/constants';
import UserAccount from '../../services/UserAccount';
import StatefulTextField from '../../components/StatefulTextField';
import StatefulButton from '../../components/StatefulButton';
import FullScreenVerticalCenterContent from '../../styledhtml/FullScreenVerticalCenterContent';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 16rem;
  p {
    margin-bottom: 2rem;
  }
`;

export default class VerificationCode extends LogictryComponent {
  static propTypes = {
    onSuccess: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.innerHeight = window.innerHeight;
    this.state = {
      warning: '',
      verificationCode: '',
      lastVerificationCodeSent: ''
    };
  }
  verifyCode = () => {
    const { verificationCode, lastVerificationCodeSent } = this.state;
    if (!verificationCode) return this.setState({ warning: 'Code missing' });
    if (verificationCode === lastVerificationCodeSent) return this.setState({ warning: 'Code invalid' });
    this.setState({ warning: '' });
    UserAccount.verifyCode(UserAccount.account.email, verificationCode).then((result) => {
      this.state.lastVerificationCodeSent = verificationCode;
      if (result?._id) this.props.onSuccess();
      else this.setState({ warning: 'Code invalid - a new one-time use code has been sent!' });
    });
  }
  render() {
    return (
      <div style={{ position: 'absolute', top: 0, right: 0, left: 0, height: Constants.isIphone ? `${this.innerHeight - 70}px` : '100%' }}>
        <FullScreenVerticalCenterContent>
          <Form>
            <h1>Enter the code</h1>
            <p>A one-time use verification code has been sent to your email.</p>
            <StatefulTextField
              value={this.state.verificationCode}
              onChange={(verificationCode) => { this.setState({ verificationCode, lastVerificationCodeSent: '' }); }}
              label="verification"
              type="text"
              id="verification"
              name="verification"
              maxLength={30}
              autoComplete="one-time-code"
              pattern="[0-9]*"
              style={{ minWidth: 120, maxWidth: '80%', width: 400 }}
              onKeyDown={(e) => { if (e.key === 'Enter') { this.verifyCode(); } }}
            />
            <div style={{ marginTop: 50, marginBottom: 50 }}><StatefulButton
              onClick={this.verifyCode}
              text="Submit"
              warning={this.state.warning}
            /></div>
          </Form>
        </FullScreenVerticalCenterContent>
      </div>
    );
  }
}
